<script setup>

import {useRoute, useRouter} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {useUserConnectStore} from "@/stores/userConnect.store";

const route = useRoute();
const router = useRouter();
const userConnectStore = useUserConnectStore();

if (route.params.id > 0) {
  userConnectStore.fetchOne(route.params.id);
} else {
  userConnectStore.userConnect = {
    type: 'emergency',
    default_connect: 'call',
  };
}

const {userConnect} = storeToRefs(userConnectStore);

const doSubmit = async () => {
  if (route.params.id  === '0') {
    await userConnectStore.createOne().then(() => {
      router.push('/connect/' + userConnect.value.id);
    });
  } else {
    await userConnectStore.updateOne(route.params.id);
  }
}

</script>

<template>
  <van-form @submit="doSubmit">
    <van-cell-group inset>
      <van-field
          v-model="userConnect.first_name"
          label="First Name"
          placeholder="First Name"
          size="large"
          required
          :rules="[{ required: true, message: 'Please input first name' }]"
      />
      <van-field
          v-model="userConnect.last_name"
          label="Last Name"
          placeholder="Last Name"
          size="large"
          required
          :rules="[{ required: true, message: 'Please input last name' }]"
      />
      <van-field
          v-model="userConnect.phone"
          label="Phone"
          placeholder="Phone"
          size="large"
          required
          :rules="[{ required: true, message: 'Please input phone' }]"
      />
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
      <van-cell>
        <template #title>
          <b>Connect Type</b>
        </template>

      </van-cell>
      <van-radio-group v-model="userConnect.type">
        <van-cell-group>
          <van-cell title="Emergency" clickable @click="userConnect.type = 'emergency'">
            <template #right-icon>
              <van-radio name="emergency"/>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="Sponsor" clickable @click="userConnect.type = 'sponsor'">
            <template #right-icon>
              <van-radio name="sponsor"/>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="Counselor" clickable @click="userConnect.type = 'counselor'">
            <template #right-icon>
              <van-radio name="counselor"/>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="Friend" clickable @click="userConnect.type = 'friend'">
            <template #right-icon>
              <van-radio name="friend"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-cell-group>


    <van-divider/>

    <van-cell-group inset>
      <van-cell>
        <template #title>
          <b>Default Connect</b>
        </template>

      </van-cell>
      <van-radio-group v-model="userConnect.default_connect">
        <van-cell-group>
          <van-cell title="Sms" clickable @click="userConnect.default_connect = 'sms'">
            <template #right-icon>
              <van-radio name="sms"/>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="Call" clickable @click="userConnect.default_connect = 'call'">
            <template #right-icon>
              <van-radio name="call"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-cell-group>
    <van-divider/>

    <van-cell-group inset>
      <van-button v-if="route.params.id === '0'" block round type="success" native-type="submit">
        Create
      </van-button>
      <van-button v-else block round type="success" native-type="submit">
        Update
      </van-button>
    </van-cell-group>


  </van-form>
</template>
